export function initAppelProjet(){

	var AppelProjet = Barba.BaseView.extend({
	namespace: 'appel-projet',
	onEnter: function() {
		// The new Container is ready and attached to the DOM.

	},
	onEnterCompleted: function() {
        const lang = document.querySelector('.barba-container').dataset.lang;
        if (lang === 'fr') {
            hbspt.forms.create({
                portalId: "5159010",
                formId: "7daf3b97-4532-42fc-a1e4-28e0a94cc28b",
                target: "#formcontainer",
                redirectUrl:"https://www.supratec-syneo.com/merci.html?success=true"
            });
        }  else  {
            hbspt.forms.create({
                region: "na1",
                portalId: "5159010",
                target: "#formcontainer",
                formId: "44c77535-ac1a-487c-a386-a76a6e46d553",
                redirectUrl:"https://www.supratec-syneo.com/thanks.html?success=true"
            });
        }

        window.addEventListener('message', event => {
            if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                // console.log('onFormSubmit')
                dataLayer.push({
                    'event': 'Page contact - soumission de formulaire',
                    'clicID': 'Soumission de formulaire'
                });
            }
        });
	}
  });

  // Don't forget to init the view!
  AppelProjet.init();



}
